"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageNames = void 0;
exports.loadFromLocalStorage = loadFromLocalStorage;
exports.saveToLocalStorage = saveToLocalStorage;
// import { logToConsole } from './debugHelper';
let LocalStorageNames = exports.LocalStorageNames = /*#__PURE__*/function (LocalStorageNames) {
  LocalStorageNames["info"] = "ori-olapic-info";
  LocalStorageNames["categories"] = "ori-olapic-categories";
  LocalStorageNames["streams"] = "ori-olapic-streams";
  return LocalStorageNames;
}({});
function loadFromLocalStorage(name) {
  try {
    const serializedData = localStorage.getItem(name);
    return JSON.parse(serializedData ?? 'null');
  } catch (error) {
    // logToConsole({ text: 'loadFromLocalStorage error:', variable: error });

    return undefined;
  }
}
function saveToLocalStorage(name, value) {
  try {
    let serializedData = '';
    serializedData = JSON.stringify(value);
    localStorage.setItem(name, serializedData);
  } catch (error) {
    // logToConsole({ text: 'saveToLocalStorage error:', variable: error });
  }
}
